import React, { Component } from 'react';
import AdSense from 'react-adsense';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const downloadUrl = {
    "32" : [
        'https://bit.ly/3i82zgr',
        'https://bit.ly/3i82zgr',
    ],
    "64" : [
        'https://bit.ly/3B0rD4V',
	'https://bit.ly/3B0rD4V',
    ]
};

class DownloadPage extends Component {
    constructor(props) {
        super(props);
    };
    state = {
        timer: -1,
        percentage: 0,
    };

    updatePercentage = () => {
        const { updatePercentage } = this;
        const { percentage } = this.state;
        if ( this.state.percentage < 100 ) {
            this.setState({
                percentage: percentage + 1,
            })
            setTimeout(function () {
                updatePercentage()
            }, 1)
        } else {
            this.setState({
                timer: 0,
            })
        }
    }

    componentDidMount() {
        const { updatePercentage } = this;
        this.setState({
            timer: 0,
        })
        updatePercentage();
    }

    render() {
        const {timer, percentage} = this.state;

        console.log('SWS', 'URL:', window.location.href);
        let bit = window.location.href.split('bit=')[1];

        if (timer >= 0) {
            if (percentage === 100) {
                const rand = Math.floor(Math.random() * downloadUrl[bit].length);
                console.log('rand=', rand);
                window.location.replace(downloadUrl[bit][rand])
                // if (bit === '32') {
                //     window.location.replace('http://bit.ly/2lukQMG')
                // } else if (bit === '64') {
                //     window.location.replace('http://bit.ly/2lumBtg')
                // }
            }
            return (
                <div className={'App-header'}>
                    <div>
                        피카부 설치 파일이 곧 다운로드됩니다.
                    </div>
                    <div className={'App-loading'}>
                        <CircularProgressbar
                            value={percentage}
                            text={`${percentage}%`}
                            styles={buildStyles({
                                // Rotation of path and trail, in number of turns (0-1)
                                rotation: 0.25,

                                // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                strokeLinecap: 'butt',

                                // Text size
                                textSize: '16px',

                                // How long animation takes to go from one percentage to another, in seconds
                                pathTransitionDuration: 0.5,

                                // Can specify path transition in more detail, or remove it entirely
                                // pathTransition: 'none',

                                // Colors
                                pathColor: `rgba(62, 152, 199, ${percentage / 100})`,
                                textColor: '#f88',
                                trailColor: '#d6d6d6',
                                backgroundColor: '#3e98c7',
                            })}
                        />
                    </div>
                    {/*<div className={'App-adsense'}>*/}
                    {/*    <AdSense.Google*/}
                    {/*        client='ca-pub-9211780780039344'*/}
                    {/*        slot='4406200016'*/}
                    {/*        style={{display: 'block'}}*/}
                    {/*        layout='in-article'*/}
                    {/*        format='fluid'*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
            );
        } else {
            return(
                <div>

                </div>
            )
        }
    }

}

export default DownloadPage;
